import { useEffect } from "react";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow, noarchive";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  return (
    <div className="grid min-h-screen w-full place-items-center bg-gradient-navy px-6">
      <div className="text-center">
        <p className="font-display text-6xl font-bold text-navy-foreground">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-navy-foreground">
          Page not found
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-navy-muted">
          The page you&rsquo;re looking for doesn&rsquo;t exist or is no longer available.
        </p>
        <Button asChild variant="cta" size="lg" className="mt-8">
          <a href="/">
            <Home className="h-4 w-4" /> Back to Anchor Web Systems
          </a>
        </Button>
      </div>
    </div>
  );
}
